import { Inject, Injectable } from '@angular/core';
import { DataService } from './data.service';
import { LogData } from '../models/logging/logging';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {

  //  Trace = 0, Debug = 1, Information = 2, Warning = 3, Error = 4, Critical = 5
  private readonly loggingBaseApiUrl: string;
  public appName = 'SDWeb';

  constructor(@Inject('BASE_URL') baseUrl: string, private dataService: DataService) {
    this.loggingBaseApiUrl = `${baseUrl}api/log`;
  }

  public logErrorMessage(error: any) {

    const messageToLog = `${this.appName}: [Error]: ${error.message} [Status]: ${error?.status} [Stack trace]: ${error?.stack}`;
    
    const logData : LogData = {
      errorMessage: messageToLog,
      logLevel: 4
      //logLevel: EnumLogLevel.Error
    }

    return this.dataService.post<any>(this.loggingBaseApiUrl, logData)
    .subscribe({
      next: (resp) => {
      },
      error: (error) => {
        console.error('Error in logging error message:', error);
      },
      complete: () => {
      }
    });
  }

  public logWarningMessage(message : string) {

    const messageToLog = `${this.appName}: [Warning]: ${message}`;
    console.log(messageToLog);
    console.log("calling backend api : " + this.loggingBaseApiUrl);

    const logData : LogData = {
      errorMessage: messageToLog,
      logLevel: 3
      //logLevel: EnumLogLevel.Warning
    }
    return this.dataService.post<any>(this.loggingBaseApiUrl, logData)
    .subscribe({
      next: (resp) => {
      },
      error: (error) => {
        console.error('Error in logging error message:', error);
      },
      complete: () => {}
    });
  }

  public logInfoMessage(message : string) {

    const messageToLog = `${this.appName}: [Information]: ${message}`;

    const logData : LogData = {
      errorMessage: messageToLog,
      logLevel: 2
      //logLevel: EnumLogLevel.Info
    }
    return this.dataService.post<any>(this.loggingBaseApiUrl, logData)
      .subscribe({
        next: (resp) => {
        },
        error: (error) => {
          console.error('Error in logging error message:', error);
        },
        complete: () => { }
      });
  }
}
